export const COLOR_MODE = "COLOR_MODE";
export const LANGUAGE = "LANGUAGE";
export const CONTENTFUL_DATA = "CONTENTFUL_DATA";

export const NECESSARY_COOKIES = "NECESSARY_COOKIES";
export const FUNCTIONAL_COOKIES = "FUNCTIONAL_COOKIES";
